module.exports = __webpack_public_path__ + "img/carousel-image3.6226c35d.jpg";